import useFetch from "@/hooks/useFetch";
import { getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import { CSSProperties, useState } from "react";
import RadioButton from "../RadioButton";
import classes from "./GiftSelect.module.css";

// import brandGift from "@/assets/svgs/brand-gift.svg";
import brandGift from "@/assets/svgs/10b.svg";
import gngGift from "@/assets/svgs/10a.svg";
// import gngGift from "@/assets/10a.png";
// import gngGift from "@/assets/10a.png";

interface Props {
  className?: string;
  style?: CSSProperties;
  title?: string;
  subTitle?: string;

  type?: "gng" | "brand";

  max?: number;
  giftRes: ReturnType<typeof useFetch<GiftItem[]>>;
  giftItems?: OfferTypeGiftItem[];

  selected: number[];
  setSelected: (index: number[]) => void;
}

const GiftSelect = ({
  className,
  style,
  title = "GIFT FROM G&G",
  // subTitle = "Choose your free gift",
  type = "gng",

  max = 1,
  giftRes,
  giftItems = [],

  selected,
  setSelected,
}: Props) => {
  const classNames = [classes.GiftSelect, className];
  const [showAllGifts, setShowAllGifts] = useState(false);
  const gifts = giftRes.response ?? [];
  const visibleGifts = gifts
  // console.log("giftRes", giftRes);

  return (
    <div className={classNames.join(" ")} style={style}>
      <div className={`${classes.item} justify-center`}>
        <div className={classes.image}>
          <Image
            src={type === "gng" ? gngGift : brandGift}
            alt="Gift Card"
            layout="responsive"
            width={100}
            height={100}
            unoptimized={true}
            style={{
              aspectRatio: 1,
              objectFit: "contain",
              maxWidth: "45px",
            }}
          />
        </div>

        <div className={classes.info}>
          <p className={` ${classes.title} mt-3 uppercase`}>{title}</p>
          {/* <p className={classes.text}>{subTitle}</p> */}
        </div>
      </div>

      <div className={`${classes.giftList} border border-gray-400 rounded-md p-5`}>
        {visibleGifts.map((gift, index) => (
          <div
            className={classes.item}
            key={index + "-gift-item"}
            onClick={() => {
              if (selected.includes(index)) {
                setSelected(selected.filter((i) => i !== index));
              } else {
                if (selected.length < max) {
                  setSelected([...selected, index]);
                } else {
                  setSelected([...selected.slice(1), index]);
                }
              }
            }}
          >
            <RadioButton active={selected.includes(index)} />
            <div
              className={`flex items-center ${
                index < (giftRes.response?.length ?? 0) - 1
                  ? "border-b border-gray-300"
                  : ""
              }`}
            >
              {gift.media && (
                <Image
                  src={getS3ImageUrl(gift.media || "")}
                  alt={gift.name}
                  // layout="responsive"
                  width={100}
                  height={100}
                  unoptimized={true}
                  style={{
                    aspectRatio: 1,
                    objectFit: "contain",
                    maxWidth: "60px",
                  }}
                />
              )}

              <p className={`${classes.title} ${classes.name}`}>
                {gift.name} x{" "}
                {giftItems.find((g) => g.id === gift.id)?.quantity ?? gift.qty}
              </p>
            </div>
          </div>
        ))}

        {/* {!giftRes.loading && gifts.length > 5 && !showAllGifts && (
          <div className="flex justify-center items-center">
            <button
            type="button"
            className=" text-sm bg-primary hover:underline text-center border border-gray-300 rounded-md px-2 py-1 text-white"
            onClick={() => setShowAllGifts(true)}
          >
            See More
          </button>
          </div>
        )} */}

        {giftRes.loading && (
          <div className={classes.item}>
            <input
              type="radio"
              className={classes.input}
              name="gift"
              id={`gift-loading`}
            />

            <div
              className={classes.image}
              style={{
                aspectRatio: 1,
                objectFit: "contain",
              }}
            />

            <p className={classes.title}>Loading...</p>
          </div>
        )}
        {!giftRes.loading && giftRes.response?.length === 0 && (
          <div className={classes.item}>
            <div
              className={classes.image}
              style={{
                aspectRatio: 1,
                objectFit: "contain",
              }}
            />

            <p className={classes.title}>No gift available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftSelect;
